export default "__VITE_ASSET__C$IveO5H__"